module.exports = __webpack_public_path__ + "img/recruit.ca2644ac.jpg";